import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Hero() {
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section className="bg-white pt-28 md:pt-36 pb-12 md:pb-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div
          ref={ref}
          className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="w-20 h-20 bg-copper/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-checkbox-circle-fill text-copper text-4xl" />
          </div>
          <h1 className="font-manrope font-extrabold text-slate-primary text-[40px] sm:text-4xl md:text-5xl leading-tight mb-5">
            Merci pour votre demande !
          </h1>
          <p className="text-slate-primary/60 text-base md:text-lg max-w-xl mx-auto">
            Votre soumission a bien été envoyée.
            <br />
            Un couvreur partenaire vous contactera sous 2h ouvrables.
          </p>
        </div>
      </div>
    </section>
  );
}